module.exports = __webpack_public_path__ + "static/media/arab27.61138590.wav";